<template>
  <transition name="fade">
    <div class="image-preview" v-if="open" @click="close">
      <img :src="src" alt="" class="image-preview-main" />
      <a href="javascript:;" @click="close" class="close"></a>
    </div>
  </transition>
</template>
<script>
import eventBus from '../eventBus';
export default {
  name: 'image-preview',
  created: function () {
    let vm = this;
    eventBus.$on('image-preview:open', src => {
      vm.toast(src);
    });
    eventBus.$on('image-preview:close', src => {
      vm.close(src);
    });
  },
  data: () => {
    return {
      open: false,
      src: '',
    };
  },
  methods: {
    toast: function (src) {
      this.open = true;
      this.src = src;
    },
    close: function () {
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.image-preview {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
  padding: 10px;
  .close {
    @extend %popup-close;
    position: absolute;
    right: 15px;
    top: 15px;
  }
  img {
    width: 95%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (orientation: landscape) {
  .image-preview {
    img {
      height: 80%;
      width: auto;
    }
  }
}
</style>
